import React, { useContext, useEffect, useMemo, useState } from "react";
import { ColDef } from "ag-grid-community";
import PaginationLayout from "../components/PaginationLayout";
import { GlobalContext } from "../context/Provider";
import henceforthApi from "../utils/henceforthApi";
import AgGridTable from "../components/ui/AgGridTable";

function UserVehicles({ _id }: any) {
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(true);
  const [state, setState] = useState({
    data: {
      data: [] as Array<any>,
      total_count: 0,
    },
  });
  const limit = 10;
  const { authState } = useContext(GlobalContext);

  if (authState.access_token) {
    henceforthApi.setToken(authState.access_token);
  }

  const onChangePagination = (newVal: number) => {
    setPage(Number(newVal));
  };

  const bookingDetails = async () => {
    setLoading(true);
    try {
      const bookDetail = await henceforthApi.CarListing.pagination(_id);
      setState(bookDetail);
    } catch {
      // ignore
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    bookingDetails();
  }, [page]);

  const columnDefs = useMemo<ColDef[]>(() => {
    return [
      {
        headerName: "Sr No.",
        minWidth: 70,
        maxWidth: 80,
        width: 75,
        valueGetter: (p) => {
          return (page - 1) * limit + (p.node?.rowIndex ?? 0) + 1;
        },
        cellClass: "font-medium text-slate-500",
      },
      {
        headerName: "Vehicle Name",
        field: "vehicle_brand_name",
        minWidth: 160,
        flex: 1.2,
        cellRenderer: (p: any) => {
          const brand = p.value || "Not available";
          const img = p.data?.image;
          return (
            <div className="flex items-center gap-2">
              {img && (
                <img
                  src={`${henceforthApi.API_FILE_ROOT_ORIGINAL}${img}`}
                  className="w-8 h-8 rounded object-cover border border-slate-200 shrink-0"
                  alt=""
                />
              )}
              <span className="font-semibold text-slate-800">{brand}</span>
            </div>
          );
        },
      },
      {
        headerName: "Vehicle Number",
        field: "licence_plate_number",
        minWidth: 130,
        width: 140,
        cellRenderer: (p: any) => {
          return (
            <span className="inline-flex px-2 py-0.5 rounded font-mono text-xs font-semibold bg-slate-100 text-slate-700 border border-slate-200">
              {p.value || "Not available"}
            </span>
          );
        },
      },
      {
        headerName: "Model (Year)",
        field: "model_of_car",
        minWidth: 110,
        width: 120,
        valueFormatter: (p) => p.value || "Not available",
      },
      {
        headerName: "Type",
        field: "vehicle_type_name",
        minWidth: 110,
        width: 120,
        cellRenderer: (p: any) => {
          return (
            <span className="inline-flex px-2 py-0.5 rounded text-[11px] font-semibold bg-blue-50 text-blue-700">
              {p.value || "Not available"}
            </span>
          );
        },
      },
      {
        headerName: "Color",
        field: "vehicle_color_name",
        minWidth: 100,
        width: 110,
        cellRenderer: (p: any) => {
          return (
            <span className="inline-flex px-2 py-0.5 rounded text-[11px] font-medium bg-slate-50 text-slate-700 border border-slate-200">
              {p.value || "Not available"}
            </span>
          );
        },
      },
      {
        headerName: "Model Name",
        field: "vehicle_model_name",
        minWidth: 130,
        flex: 1,
        valueFormatter: (p) => p.value || "Not available",
      },
      {
        headerName: "Status",
        field: "is_proof_verified",
        minWidth: 110,
        width: 120,
        cellRenderer: (p: any) => {
          return p.value ? (
            <span className="inline-flex px-2 py-0.5 rounded text-[11px] font-bold uppercase bg-emerald-50 text-emerald-700 border border-emerald-200">
              Verified
            </span>
          ) : (
            <span className="inline-flex px-2 py-0.5 rounded text-[11px] font-bold uppercase bg-amber-50 text-amber-700 border border-amber-200">
              Pending
            </span>
          );
        },
      },
    ];
  }, [page]);

  return (
    <>
      <AgGridTable
        rowData={state?.data?.data || []}
        columnDefs={columnDefs}
        loading={loading}
        domLayout="autoHeight"
        emptyMessage="No vehicles found"
      />

      <div className="mt-3">
        <PaginationLayout
          count={state?.data?.total_count || 0}
          data={state?.data?.data || []}
          page={page}
          limit={Number(limit)}
          loading={loading}
          onPageChange={(val) => onChangePagination(val)}
        />
      </div>
    </>
  );
}

export default UserVehicles;

